<template>
  <div id="app">
    <!-- 全局导航头部 -->
    <NavHeader v-if="!$route.meta.guest" />
    
    <transition name="fade" mode="out-in">
      <div class="router-view-container" :class="{ 'has-nav': !$route.meta.guest }">
        <router-view/>
      </div>
    </transition>

    <NavFooter v-if="!$route.meta.guest" />
  </div>
</template>

<script>
import NavHeader from '@/components/layout/NavHeader.vue'
import NavFooter from '@/components/layout/NavFooter.vue';

export default {
  name: 'App',
  components: {
    NavHeader,
    NavFooter
  }
}
</script>

<style>
/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

#app {
  width: 100%;
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f5f7fa;
}

/* 页面过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 确保内容区域在头部下方 */
.router-view-container {
  width: 100%;
  min-height: 100vh;
}

.router-view-container.has-nav {
  padding-top: 64px; /* 与导航栏高度一致 */
}

/* 移动端优化 */
@media (max-width: 768px) {
  .router-view-container.has-nav {
    padding-top: 64px; /* 移动端导航栏高度 */
  }
  
  /* 防止移动端滚动卡顿 */
  * {
    -webkit-overflow-scrolling: touch;
  }
}

/* 防止移动端100vh问题 */
@supports (-webkit-touch-callout: none) {
  .router-view-container {
    min-height: -webkit-fill-available;
  }
}
</style>